import { MAX_RUBRIC_SCORE } from '../config';

export function calculateGroupScore(group) {
  if (!group) return 0;
  let total = 0;

  const parse = (val) => parseFloat(val) || 0;

  const calcComplexSection = (sectionData) => {
    if (!sectionData || !Array.isArray(sectionData)) return;

    sectionData.forEach((item) => {
      const worth = parse(item.worth);
      const A = parse(item.aesthetics);
      const F = parse(item.functionality);
      const aesWeight = item.aestheticsBonus ? 0.3 : 0.2;
      const percentage = 0.8 * F + aesWeight * A;
      total += Math.min(worth * (percentage / 100), worth);
    });
  };

  calcComplexSection(group.basicFeatures);

  const calcSimpleSection = (sectionData) => {
    if (!sectionData || !Array.isArray(sectionData)) return;
    sectionData.forEach((item) => {
      total += parse(item.score);
    });
  };

  calcSimpleSection(group.deployment);

  const base = total;
  let bonusPoints = 0;
  (group.bonus || []).forEach((item) => {
    const worth = parse(item.worth);
    const A = parse(item.aesthetics);
    const F = parse(item.functionality);
    const aesWeight = item.aestheticsBonus ? 0.3 : 0.2;
    const percentage = 0.8 * F + aesWeight * A;
    bonusPoints += Math.min(worth * (percentage / 100), worth);
  });

  return Math.min(base + bonusPoints, MAX_RUBRIC_SCORE);
}
